import { parseISO } from 'date-fns/parseISO';

type Context = {
  destinationId?: string;
  originId?: string;
  date: string;
};

const buildUrlPathPrefix = (context: Context) => {
  if (context.destinationId) {
    return '/transport/flights';
  }
  return '/transport/flights-from';
};

const buildPlacePath = (context: Context) => {
  let path = '';
  if (context.originId) {
    path = `/${context.originId.toLowerCase()}`;
  }
  if (context.destinationId) {
    path += `/${context.destinationId.toLowerCase()}`;
  }
  return path;
};

const buildDateYYMM = (dateString: string) => {
  if (dateString === 'anytime') {
    return '';
  }
  const date = parseISO(dateString);

  const year = date.getFullYear().toString().substr(-2);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  return `${year}${month}`;
};

const buildUrlPath = (context: Context) =>
  `${buildPlacePath(context)}/${buildDateYYMM(context.date)}`;

const buildUrl = (context: Context) => {
  if (!context) {
    throw new Error('Context not set');
  }
  return `${buildUrlPathPrefix(context)}${buildUrlPath(context)}`;
};

export default buildUrl;
